export class CaixaConferenciaRequest {
    constructor(
        public codigoCaixaCab: number = 0,
        public itens: CaixaConferenciaItens[] = []
    ) { }
}

export class CaixaConferenciaItens
{
    constructor(
        public codigoFormaPgto: number,
        public total: number,
        public conferencia: number
    ) { }

}
